import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { connect } from 'react-redux';
import { setIsLoading, setServiceToDisconnect , setDisconnectTypeOfService , getCustomerServicesAvailableToDiscconect, goToPage, stepParams, checkCanDisconnectService } from '../DisconnectServiceSlice'
import './ServicesList'
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import images from '../DisconnectPhotos/images'
import { Container } from 'reactstrap';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';

function ServicesList(props) {

    //const [isLoading, SetLoader] = useState(true);

    //useEffect(() => {
    //    async function getContactList() {
    //        props.showAppLoader()
    //        await props.getCustomerServicesAvailableToDiscconect();
    //        //SetLoader(false);
    //        props.setIsLoading(false)
    //        props.hideAppLoader();
    //    }
    //    getContactList();
    //},[])

    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
            async function getContactList() {
                props.showAppLoader()
                await props.getCustomerServicesAvailableToDiscconect();
                props.setIsLoading(false);
                props.hideAppLoader();
            }
            getContactList();
        }
    }, []);

    async function redirectToRelevantPage(item) {
        props.setDisconnectTypeOfService(item.ServiceType);
        props.setServiceToDisconnect(item);
        if(item.canDisconnectOnline === false) {
            props.goToPage({ page: 'GET_BACK_TO_YOU_BY_NUMBER', params: { ...stepParams, hideHeader: false, serviceToDisconnect: item } })
            return;
        }
        props.showAppLoader();
        await props.checkCanDisconnectService(item);
        props.hideAppLoader();
    }

    return (
        <Container className="servicesList-container-root">
            {props.isLoading === false ?
            <div className="servicesList-container">
                {props.isLoading === false && props.userServices && props.userServices.length == 0 ? 
                <div className="txtSection" style={{height: 'auto'}}>
                <strong>
                רק שנייה,
                <br />
                אנחנו לא מזהים שיש לכם מוצר שניתן לנתק
                <br />
                </strong>
                <br />
                אם תרצו לברר את הנושא אנחנו זמינים ב{window.Config.technicalSupportPhone}
                <br />
                &nbsp;
                <br />
                </div>
                :
                <div className="txtSection">
                ואם בכל זאת נפרדים, 
                <br/> 
                נמשיך לבחירת השירות לניתוק 
                </div> 
                }
                {props.userServices.length > 0 && props.userServices.map(function(item, i) {
                    return (
                        <div key={i} className="serviceBox">
                            <div className="serviceDetails">
                                {item.serviceType == "Cellular" ? <div className="bolded-title"><strong>{item.title} {item.subscriberNumber}</strong></div> : <div className="bolded-title"><strong>{item.title}</strong></div>}
                                {item.email == null ? null : <div className="item-data">{item.email}</div>}
                                {item.serviceType == "Mapa" ? <div className="item-data">{item.subscriberNumber}</div> : null}
                                <div className="item-data">בכתובת: &nbsp; { item.address}</div>
                                <div className="item-data">מספר לקוח: &nbsp; { item.customerId}</div>
                            </div>
                            <div className="disconnectBtn" onClick= {() => redirectToRelevantPage(item)}>ניתוק
                                <Image className="pinkCircle" src={images.disconnect} alt="disconnect-btn" />
                            </div>
                        </div>
                    )
                })}
            </div> : null }
        </Container>
    )
}

const mapStateToProps = (state) => ({
    userServices: state.disconnectServicesBlock.userServices,
    stepParams: state.disconnectServicesBlock.stepParams,
    loaderError: state.disconnectServicesBlock.loaderError,
    serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect,
    businessTypeCanBeDisconnected: state.disconnectServicesBlock.businessTypeCanBeDisconnected,
    isLoading: state.disconnectServicesBlock.isLoading
});
  
const mapDispatchToProps = {
    getCustomerServicesAvailableToDiscconect,
    goToPage,
    setDisconnectTypeOfService,
    setServiceToDisconnect,
    checkCanDisconnectService,
    showAppLoader,
    hideAppLoader,
    setIsLoading
};
  
export default connect(mapStateToProps, mapDispatchToProps)(ServicesList);
